import { Flex, Heading, IconButton, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { BsArrowLeftCircle } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';

type AdminHeaderProps = {
  title: string;
  description: string;
};

const AdminHeader: FC<AdminHeaderProps> = ({ title, description }) => {
  const history = useHistory();
  return (
    <Flex alignItems="center" gridGap="2">
      <IconButton
        icon={<BsArrowLeftCircle />}
        aria-label="voltar"
        onClick={() => history.goBack()}
        backgroundColor="transparent"
      />
      <Flex direction="column" alignItems="flex-start" gap={2}>
        <Heading as="h3" fontSize="lg">
          {title}
        </Heading>
        <Text opacity="0.8" fontSize="sm">
          {description}
        </Text>
      </Flex>
    </Flex>
  );
};
export default AdminHeader;
